// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"UZ","skip_info":"VZ","skipped":"WZ","modify_order":"XZ","cancel_subscription_btn":"YZ","byb":"ZZ","modify_order_outer":"a-","byb_edit_btn":"b-","modify_order_item":"c-","cancel_copy_wrapper":"e-","cancelled_copy":"f-"};
    if(module.hot) {
      // 1721922367472
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  